/* eslint-disable react/prop-types */
import {
  Button,
  InputNumber,
  notification,
  Popconfirm,
  Select,
  Space,
  Table,
  Typography,
} from "antd";
import { toastrErrorAlert } from "components/Common/AlertToastr";
import { GET_CONFIG, GET_SYSCFG } from "helpers/url_helper";
import React, { useEffect, useState } from "react";
import { Container } from "reactstrap";
import httpService from "services/httpService";
import { Form, Input } from "antd";
import { useRef } from "react";
import { SearchOutlined } from "@ant-design/icons";
import request from "request";

const EditableCell = ({
  editing,
  dataIndex,
  title,
  inputType,
  record,
  index,
  children,
  ...restProps
}) => {
  const inputNode = inputType === "number" ? <InputNumber /> : <Input />;
  return (
    <td {...restProps}>
      {editing ? (
        <Form.Item
          name={dataIndex}
          style={{
            margin: 0,
          }}
          rules={[
            {
              required: true,
              message: `Vui lòng nhập ${title.toLowerCase()}!`,
            },
          ]}
        >
          {inputNode}
        </Form.Item>
      ) : (
        children
      )}
    </td>
  );
};

export default function MixingRule() {
  const [mixingRule, setMixingRule] = useState([]);
  const [mixingRuleTemp, setMixingRuleTemp] = useState([]);
  const [category, setCategory] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const searchInput = useRef();
  const [api, contextHolder] = notification.useNotification();
  const [categoryNotConfig, setCategoryNotConfig] = useState([]);

  useEffect(() => {
    getMixingRule();
  }, [JSON.stringify(mixingRule)]);

  const getMixingRule = async () => {
    try {
      const getConfig = await httpService.get(
        `${GET_CONFIG}?include=["params.test"]`
      );

      const getCategory = await httpService.get(
        `${GET_SYSCFG}?where={"Category": "questionCategory"}&order=-createdAt`
      );

      const categoryMap = getCategory.results?.map(category => {
        return category.objectId;
      });

      const getConfigMap = getConfig.params.testMixingRule?.map(item => {
        return item.category.objectId;
      });

      const categoryNotConfig = getCategory.results.reduce(
        (newArray, category) => {
          if (
            !getConfigMap.includes(category.objectId) &&
            newArray !== undefined &&
            category.objectId !== "nBHAwgRxHL"
          ) {
            newArray.push(category);
          }
          return newArray;
        },
        []
      );

      const configMap = getConfig.params.testMixingRule.map((item, index) => {
        if (categoryMap.includes(item.category.objectId)) {
          const findCategory = getCategory.results?.find(
            category => category.objectId === item.category.objectId
          );

          return {
            ...item,
            index,
            Name: findCategory.Name,
          };
        }

        return { ...item, index };
      });
      setCategory(getCategory.results);
      setMixingRule(configMap);
      setMixingRuleTemp(configMap);
      setCategoryNotConfig(categoryNotConfig);
    } catch (error) {
      toastrErrorAlert(error);
    }
  };

  const getColumnSearchProps = dataIndex => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div style={{ padding: 8 }} onKeyDown={e => e.stopPropagation()}>
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={e =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({ closeDropdown: false });
              setSearchText(selectedKeys[0]);
              setSearchedColumn(dataIndex);
            }}
          >
            Filter
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            close
          </Button>
        </Space>
      </div>
    ),
    filterIcon: filtered => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) => {
      return record[dataIndex]
        .toString()
        .toLowerCase()
        .includes(value.toLowerCase());
    },
    onFilterDropdownOpenChange: visible => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: text => {
      return searchedColumn === dataIndex ? <p>{text}</p> : text;
    },
  });

  const [form] = Form.useForm();
  const [editingKey, setEditingKey] = useState("");
  const isEditing = record => record?.index === editingKey;

  const edit = record => {
    form.setFieldsValue({
      ...record,
    });
    setEditingKey(record.index);
  };
  const cancel = () => {
    setEditingKey("");
    setMixingRule(mixingRuleTemp);
  };

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = clearFilters => {
    clearFilters();
    setSearchText("");
  };
  const save = async row => {
    try {
      await form.validateFields();
      mixingRule[row.index].numberOfQuestions =
        form.getFieldsValue().numberOfQuestions;

      setMixingRule(prev =>
        prev.map(item => {
          if (item.index === row.index) {
            return {
              ...item,
              numberOfQuestions: form.getFieldsValue().numberOfQuestions,
            };
          }
          return item;
        })
      );

      sendRequestConfig(
        { testMixingRule: mixingRule },
        "Chỉnh sửa thành công!!"
      );

      setEditingKey("");
    } catch (error) {
      console.log("show eror", error);
    }
  };
  const columns = [
    {
      title: "Tên chủ đề",
      dataIndex: "Name",
      width: "50%",
      editable: false,
      ...getColumnSearchProps("Name"),
    },
    {
      title: "Số câu hỏi",
      dataIndex: "numberOfQuestions",
      width: "25%",
      editable: true,
    },
    {
      title: "Tuỳ chọn",
      dataIndex: "operation",
      render: (_, record) => {
        const editable = isEditing(record);
        return editable ? (
          <span>
            <Typography.Link
              onClick={() => save(record)}
              style={{
                marginRight: 8,
              }}
            >
              Lưu
            </Typography.Link>
            <Popconfirm title="Sure to cancel?" onConfirm={cancel}>
              <a>Huỷ</a>
            </Popconfirm>
          </span>
        ) : (
          <Space>
            <Button disabled={editingKey !== ""} onClick={() => edit(record)}>
              Sửa
            </Button>
            <Popconfirm
              title="Xoá chủ đề"
              description="Bạn có chắc chắn muốn xoá chủ đề trong logic trộn đề này hay không?"
              onConfirm={() => handleDeleteCategory(record)}
              okText="Có"
              cancelText="Không"
            >
              <Button danger>Xoá</Button>
            </Popconfirm>
          </Space>
        );
      },
    },
  ];
  const mergedColumns = columns.map(col => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: record => ({
        record,
        inputType: col.dataIndex === "numbersOfQuestion" ? "number" : "text",
        dataIndex: col.dataIndex,
        title: col.title,
        editing: isEditing(record),
      }),
    };
  });

  const onChange = async value => {
    const categorySelected = category.filter(
      category => category.objectId === value
    );
    const newCategory = {
      numberOfQuestions: "0",
      category: {
        objectId: categorySelected[0]?.objectId,
        __type: "Pointer",
        className: "SysCfg",
      },
      index: mixingRule.length,
      Name: categorySelected[0]?.Name,
    };

    sendRequestConfig(
      { testMixingRule: [newCategory, ...mixingRule] },
      "Thêm chủ đề thành công!!"
    );
    setMixingRule(prev => [newCategory, ...prev]);
  };

  const handleDeleteCategory = record => {
    sendRequestConfig(
      {
        testMixingRule: mixingRule.filter(item => item.index !== record.index),
      },
      "Xoá chủ đề thành công!!"
    );
    setMixingRule(prev => prev.filter(item => item.index !== record.index));
  };

  const sendRequestConfig = async (params, messageSuccess) => {
    request({
      method: "PUT",
      url: `${process.env.REACT_APP_BASE_URL}parse/config`,
      headers: {
        "X-Parse-Application-Id": "SCWASRTWK1Y9AVMP1KFC",
        "X-Parse-Master-Key": "LASDK106JKHR87SDFJSDHF0DFHASFDF",
      },
      json: true,
      body: {
        params,
      },
    });
    api.success({
      message: messageSuccess,
    });
  };
  return (
    <React.Fragment>
      {contextHolder}
      <div className="page-content">
        <Container fluid>
          <h4 className="my-0 font-size-18 text-capitalize mb-2">
            Logic trộn đề
          </h4>
          <Form form={form} component={false}>
            <Select
              showSearch
              placeholder="Chọn loại"
              optionFilterProp="children"
              filterOption={(input, option) =>
                (option?.Name ?? "").toLowerCase().includes(input.toLowerCase())
              }
              options={categoryNotConfig.map(item => {
                return { ...item, label: item?.Name, value: item.objectId };
              })}
              size="large"
              style={{ width: "100%" }}
              onChange={onChange}
            />
            <Table
              key={mixingRule}
              components={{
                body: {
                  cell: EditableCell,
                },
              }}
              bordered
              dataSource={mixingRule}
              columns={mergedColumns}
              rowClassName="editable-row"
              pagination={{
                onChange: cancel,
              }}
            />
          </Form>
        </Container>
      </div>
    </React.Fragment>
  );
}
